import { State } from '.';
import { SpecialtyModel } from '../../models/specialty';

export const selectors = {
    getSpecialty: (
        state: State,
        id: Undefinable<DictionaryKey>
    ): Undefinable<SpecialtyModel> => state.byId[id || ''],
    getSpecialtyIds: (
        state: State
    ): number[] => state.allIds
};
